import { useState as a, useEffect as k } from "react";
const t = (c) => {
  const e = document.cookie.match(`(?:^|.*)${c}=(.+?)(?:$|[|;].*)`);
  return e ? e[1] : void 0;
};
function v(c, e) {
  const u = Object.assign({
    checkEvery: 250,
    valueOnly: !1
  }, e != null ? e : {}), [r, n] = a(t(c));
  return k(() => {
    const o = window.setInterval(() => n(t(c)), u.checkEvery);
    return () => window.clearInterval(o);
  }), (e == null ? void 0 : e.valueOnly) === !0 ? r : r !== void 0;
}
const i = (c) => t(c);
export {
  i as useCookie,
  v as useCookieWatcher
};
